import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../utils/customHooks';
import { useNavigate } from 'react-router-dom';
import {
  fileAddTC,
  filedCheckTC,
  sendVisaStepTC,
  updateApplicantField
} from '../../../store/visaPageReducer';
import Button from '../../../shared/Button/Button';
import FileInput from '../../../shared/FileInput/FileInput';
import Input from '../../../shared/Input/Input';
import Label from '../../../components/Label/Label';
import FotoUploadModal from '../Modal/FotoUploadModal';
import SignField from "../../../components/SignField/SignField";
import { setErrorMessageAC, setMessageTC } from "../../../store/appReducer";
import Checkbox from "../../../shared/Checkbox/Checkbox";


const checkFields = [
  'passportCopyFiles',
  'photoFiles',
  'hotelsData',
  'inTicketsFiles',
  'outTicketsFiles',
  'signFiles'
]


const VisaPage7Item = ({ index, isPH, setSelectedAndErrorField, errorField }: {
  index: number, isPH?: boolean, setSelectedAndErrorField: (index: number, fieldName: string) => void,
  errorField: null | string,
}) => {
  const main_applicant = useAppSelector(state => state.visa_page.applicantsData[0])
  const applicant = useAppSelector(state => state.visa_page.applicantsData[index])
  const {
    passportCopyFiles,
    photoFiles,
    inTicketsFiles,
    outTicketsFiles,
    hotelsData,
    signFiles
  } = applicant
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(errorField)

  const addItem = () => {
    let editedObj = [...hotelsData, {
      hotelName: '',
      arrivalDate: '',
      departureDate: '',
      hotelAddress: '',
      bookingHotel: []
    }]
    dispatch(updateApplicantField({
      fieldName: 'hotelsData',
      value: editedObj,
      index
    }));
  }
  const delItem = (i: number) => {
    let editedObj = hotelsData.filter((el, eli) => eli !== i)
    dispatch(updateApplicantField({
      fieldName: 'hotelsData',
      value: editedObj,
      index
    }));
  }

  const onBlurDatesHandler = async (name: string, value: string, elIndex: number) => {

    let editedObj = hotelsData.map((el, index) => {
      return index === elIndex ? { ...el, [name]: value } : el
    })
    dispatch(updateApplicantField({
      fieldName: 'hotelsData',
      value: editedObj,
      index
    }));
    return value
  }

  const onChangeHandler = async (fieldName: string, files: FileList | null, elementIndex: number) => {
    let arr: Array<string>
    if (files) {
      if (Array.from(files).some((el) => el.size > 4500000)) {
        return dispatch(setErrorMessageAC({
          message: 'Максимальный размер файла 4.5МБ'
        }))
      }
      let res = await dispatch(fileAddTC({ files }))
      arr = res.payload as Array<string>
      let editedObj = hotelsData.map((el, i) => {
        return i === elementIndex ? { ...el, bookingHotel: arr } : el
      })
      dispatch(updateApplicantField({
        fieldName: 'hotelsData',
        value: editedObj,
        index
      }));
    }
  }

  const resetHandler = (fieldName: string, elementIndex: number) => {
    let editedObj = hotelsData.map((el, i) => {
      return i === elementIndex ? { ...el, bookingHotel: [] } : el
    })
    dispatch(updateApplicantField({
      fieldName: 'hotelsData',
      value: editedObj,
      index
    }));
  }

  const copyHotelData = () => {
    dispatch(updateApplicantField({
      fieldName: 'hotelsData',
      value: main_applicant.hotelsData,
      index
    }));
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    const isEveryFilled = checkFields.every((field) => {
      if (Array.isArray(applicant[field])) {
        if (field === 'hotelsData') {
          const isEveryHotelFilled = applicant[field].every((hotel, i) => {
            if (!hotel.hotelName.trim()) {
              setError(`hotelName-${i}`)
              return false
            }
            if (!hotel.hotelAddress.trim()) {
              setError(`hotelAddress-${i}`)
              return false
            }
            if (!hotel.arrivalDate?.length) {
              setError(`arrivalDate-${i}`)
              return false
            }
            if (!hotel.departureDate?.length) {
              setError(`departureDate-${i}`)
              return false
            }
            if (!hotel.bookingHotel?.length) {
              setError(`bookingHotel-${i}`)
              return false
            }
            return true
          })
          if (!isEveryHotelFilled) return false
        }
        if (!applicant[field].length) {
          setError(field)
          return false
        }
      }

      if (typeof applicant[errorField as keyof typeof applicant] === 'string' &&
        !(applicant[errorField as keyof typeof applicant] as string).trim().length) {
        setError(field)
        return false
      }
      return true
    })

    if (!isEveryFilled) {
      dispatch(setMessageTC({ message: `Заполните поля у всех заявителей`, isError: true }))
      return
    }

    const res = await dispatch(filedCheckTC({
      passportCopyFiles,
      photoFiles,
      inTicketsFiles,
      outTicketsFiles,
      signFiles
    })) as {
      payload: { isSuccess: boolean, applicantIndex?: number, fieldName?: string }
    }
    if (res.payload && res.payload.isSuccess) {
      await dispatch(sendVisaStepTC())
      navigate('/visa8')
    }
    if (res.payload.applicantIndex !== undefined && res.payload.fieldName) {
      setSelectedAndErrorField(res.payload.applicantIndex, res.payload.fieldName)
      dispatch(setMessageTC({ message: `Заполните поля у всех заявителей`, isError: true }))
    }
  }

  useEffect(() => {
    if (!errorField) {
      setError(null)
      return
    }

    // bookingHotel
    if (errorField.startsWith('bookingHotel-')) {
      const i = Number(errorField.split('-')[1])
      if (!hotelsData[i]?.bookingHotel?.length) {
        setError(errorField)
        return
      }
    }

    // hotelName / hotelAddress
    if (errorField.startsWith('hotelName-') || errorField.startsWith('hotelAddress-') || errorField.startsWith('arrivalDate-') || errorField.startsWith('departureDate-')) {
      const [field, idxStr] = errorField.split('-')
      const i = Number(idxStr)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      if (!hotelsData[i]?.[field]?.trim()) {
        setError(errorField)
        return
      }
    }

    // стандартные проверки
    if (applicant[errorField as keyof typeof applicant]) {
      if (
        Array.isArray(applicant[errorField as keyof typeof applicant]) &&
        !(applicant[errorField as keyof typeof applicant] as Array<any>).length
      ) {
        setError(errorField)
        return
      } else if (
        typeof applicant[errorField as keyof typeof applicant] === 'string' &&
        !(applicant[errorField as keyof typeof applicant] as string).trim().length
      ) {
        setError(errorField)
        return
      }
    }

    setError(null)
  }, [
    errorField,
    hotelsData,
    passportCopyFiles,
    photoFiles,
    inTicketsFiles,
    outTicketsFiles,
    signFiles
  ])

  return (
    <form className="mt-6 mb-4" onSubmit={handleSubmit}>
      <FotoUploadModal initialState={!photoFiles.length}/>
      <div className="space-y-8">
        <FileInput fieldName={'passportCopyFiles'}
                   borderClassName={error === 'passportCopyFiles' ? '!border-rose-600' : ''}
                   title={'Копия паспорта (со сроком окончания действия не менее 6 месяцев)'} index={index}/>

        <FileInput borderClassName={error === 'photoFiles' ? '!border-rose-600' : ''} fieldName={'photoFiles'}
                   title={'Ваша фотография студийного качества'} index={index}
                   types={'image/png, image/jpeg, image/jpg'} typesName={'PNG, JPG, JPEG'}/>
        {index > 0 &&
          <div>
            <Label>Данные отелей в Сингапуре</Label>
            <Checkbox onChange={copyHotelData} name="copy hotel" label="Скопировать данные отелей у основного заявителя"
                      className="mt-4"/>
          </div>
        }
        {hotelsData.map((el, elementIndex) => {
          return (
            <div key={elementIndex}>
              <div className="flex flex-col sm:grid gap-3 mt-4 grid-rows-3 grid-flow-col">
                <div className={'col-span-2'}>
                  <Label className="text-center">Название отеля</Label>
                  <Input
                    className={`mt-2 ${error === `hotelName-${elementIndex}` ? '!border-rose-600' : ''}`}
                    type="text"
                    placeholder={'Укажите название отеля'}
                    required
                    value={el.hotelName}
                    onChange={(e) => {
                      if (/[А-яЁё]/i.test(e.currentTarget.value)) {
                        return
                      }
                      onBlurDatesHandler('hotelName', e.currentTarget.value, elementIndex)
                    }}
                  />
                </div>
                <div className={'col-span-2'}>
                  <Label className="text-center">Полный адрес отеля</Label>
                  <Input
                    className={`mt-2 ${error === `hotelAddress-${elementIndex}` ? '!border-rose-600' : ''}`}
                    type="text"
                    placeholder={'Укажите полный адрес отеля'}
                    required
                    value={el.hotelAddress}
                    onChange={(e) => {
                      if (/[А-яЁё]/i.test(e.currentTarget.value)) {
                        return
                      }
                      onBlurDatesHandler('hotelAddress', e.currentTarget.value, elementIndex)
                    }}
                  />
                </div>
                <div>
                  <Label className="text-center">Дата заселения</Label>
                  <Input
                    className={`mt-2 ${error === `arrivalDate-${elementIndex}` ? '!border-rose-600' : ''}`}
                    type="date"
                    required
                    value={el.arrivalDate}
                    onChange={(e) => {
                      onBlurDatesHandler('arrivalDate', e.currentTarget.value, elementIndex)
                    }}
                  />

                </div>
                <div>
                  <Label className="text-center">Дата выселения</Label>
                  <Input
                    className={`mt-2 ${error === `departureDate-${elementIndex}` ? '!border-rose-600' : ''}`}
                    type="date"
                    required
                    value={el.departureDate}
                    onChange={(e) => {
                      onBlurDatesHandler('departureDate', e.currentTarget.value, elementIndex)
                    }}
                  />

                </div>
                <div className={'sm:row-span-2 sm:self-center sm:mt-5'}>
                  {elementIndex !== 0 && <div onClick={() => {
                    delItem(elementIndex)
                  }}
                                              className={'self-end p-2 mt-2 sm:w-[40px] flex-shrink-0 text-center mx-auto cursor-pointer rounded-full bg-red-500'}>-</div>}
                  <div onClick={() => {
                    addItem()
                  }}
                       className={'self-end p-2 mt-24 sm:w-[40px] flex-shrink-0 text-center mx-auto cursor-pointer rounded-full bg-neutral-200 dark:bg-gray-700'}>+
                  </div>
                </div>
              </div>
              <div className="mt-2">
                <FileInput fieldName={'hotelsData'}
                           borderClassName={error === `bookingHotel-${elementIndex}` ? '!border-rose-600' : ''}
                           innerIndex={elementIndex}
                           innerName={'bookingHotel'}
                           callback={onChangeHandler}
                           resetCallBack={resetHandler}
                           title={'Загрузите скриншот выбранного вами отеля'}
                           index={index}/>
              </div>
            </div>
          )
        })}
        <FileInput borderClassName={error === 'inTicketsFiles' ? '!border-rose-600' : ''} fieldName={'inTicketsFiles'}
                   multiple={true} title={'Билеты/круиз в Сингапур'}
                   index={index}/>

        <FileInput fieldName={'outTicketsFiles'} multiple={true} title={'Билеты/круиз из Сингапура'}
                   index={index}/>

        <FileInput fieldName={'workPlaceFiles'} multiple={true} title={'Справка с места работы (не обязательно)'}
                   index={index}/>

        <FileInput fieldName={'additionFiles'} multiple={true} title={'Дополнительные документы'}
                   index={index}/>

        <SignField borderClassName={error === 'signFiles' ? '!border-rose-600' : ''} index={index}
                   signFiles={signFiles}/>
      </div>
      <div className="flex justify-end space-x-5 mt-8">
        <Button
          className={`ttnc-ButtonSecondary font-medium border bg-white border-neutral-200 text-neutral-700 dark:bg-neutral-900 dark:text-neutral-300 dark:border-neutral-700 hover:bg-neutral-100 dark:hover:bg-neutral-800`}
          href={'/visa6'}>Назад</Button>
        <Button
          className={`ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50 ${isPH ? 'bg-[#4f46e5] hover:bg-[#4f46e5]/95' : ''} dark:text-neutral-200`}
          type={'submit'}
        >Продолжить
        </Button>
      </div>
    </form>
  )
    ;
};

export default VisaPage7Item;
